import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectPreselectedFormsCount = createSelector(
  [
    (store: RootState) => store.profileFormAssigned.preselectedForms,
  ],
  (preselectedForms) => preselectedForms.length
);